import getAxiosInstance from '../../helpers/get_axios_instance'
import lrsAdapter from '../../helpers/lrs_adapter'

class EstadisticasVolcadora {
  static getEstadisticasVolcadoras (fechaD, fechaH) {
    const axios = getAxiosInstance()
    const filtro = `{"clave":{"fecha_desde": "${fechaD}", "fecha_hasta": "${fechaH}"}}`
    const promise = axios.get(`consulta_estadistica_volcadora?r=${filtro}`)
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then(result => result.data)
  }
}
export default EstadisticasVolcadora
